const MindfulMinute = class MindfulMinute {
    constructor() {
        this.id = null;
        this.title = '';
        this.video = null;
        this.videoName = null;
        this.poster = null;
        this.poster_name = null;
        this.feedLabel = '';
    }
};

export default MindfulMinute;
